import { useState, useEffect } from 'react';
import '../../styles/StudentComponents/StAdvantages.css';
import learnersImage from '../../assets/Images/Group 275.webp'; 
import { Link } from 'react-router-dom';

const steps = [
  {
    id: 1,
    title: 'Discover Tailored Learning Experience',
    content: `Discover instructors who see the unique potential in every learner and know exactly how to nurture it into remarkable skills that last a lifetime—whether you're beginning your journey or supporting someone else's.`,
  },
  {
    id: 2,
    title: 'Connect with a Vibrant Learning Community',
    content: `Step into a supportive network where growth happens naturally alongside peers who share your interests, guided by mentors who remember what it's like to discover something amazing for the first time.`,
  },
  {
    id: 3,
    title: 'Find courses to unlock your true potential',
    content: `From robotics to piano, creative writing to chess—explore possibilities that conventional education simply can't provide. Find those special abilities that make you or your child uniquely brilliant in ways standardized testing never measures.`,
  },
];

function StAdvantages() {
  const [activeStep, setActiveStep] = useState(1);

  
    useEffect(() => {
      if (window.innerWidth < 600) {
        const heading = document.querySelector('.emp-heading');
        if (heading) {
          heading.innerHTML = "Unlock your potential with personalized learning experiences tailored just for you";
        }
      }
    }, []);
  return (
    <>

    <div className="st-empowering-container">
      <div className="st-empowering-left">
        <h2 className='st-emp-heading'>
        Get your academy on Strawket and get a fee credit!
        </h2>
        <p>
        Already part of an amazing academy? < br/><span className='sa'>
        Share the Strawket advantage with them and watch their teaching transform while you receive a special thank-you credit that you can use toward your own learning adventures.</span>
        </p>
        <Link to="/academies">
        <button className="st-empower-button">Refer Now</button>
        </Link>
      </div>
      <div className="st-empowering-right">
        <img src={learnersImage} alt="Educator and student" />
      </div>
    </div>
</>
  );
}

export default StAdvantages;
